import { render, staticRenderFns } from "./NewProfileview.vue?vue&type=template&id=77888d3e"
import script from "./NewProfileview.vue?vue&type=script&lang=js"
export * from "./NewProfileview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports